/**
 * エラーログをサーバーに送る
 * @param {String} error エラーテキスト
 */

window.errorLog = function (error) {
  /* global hUrl */

  const url = hUrl + 'api/'

  let errorText = 'JS Error: '
  errorText += window.navigator.userAgent + '\n'
  errorText += error

  const param = 'error_log=1&error_text=' + errorText

  try {
    applyAjax(url, param)
  } catch (error) {
    console.log(error)
  }

  function applyAjax(url, param) {
    const ajax = new XMLHttpRequest() // Ajaxリクエスト

    ajax.open('post', url, true) // GET/POST, URL, 非同期処理

    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')

    ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー

    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    ajax.send(param) // POSTリクエスト実行
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
    }
  }
  console.log(error)
}
